import {useMutation} from 'react-query';
import postBrandStoreOrder, {
  IPostBrandStoreOrderPayload,
} from './postBrandStoreOrder';
import {AxiosError} from 'axios';
import {toast} from 'react-toastify';

const usePostBrandStoreOrder = (handleAfterSuccess?: () => void) => {
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (payload: IPostBrandStoreOrderPayload) => {
      return postBrandStoreOrder(payload);
    },
    onSuccess: data => {
      handleAfterSuccess && handleAfterSuccess();
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });

  return {isLoading, mutate, isSuccess};
};

export default usePostBrandStoreOrder;
